import { BOTTOM_PINNED_TOTAL_ROW_ID } from '@constants'

export const isBottomPinnedTotalRow = (id?: string) => {
  return id?.startsWith(BOTTOM_PINNED_TOTAL_ROW_ID)
}
